import React, { useMemo } from "react";
import {
  type Icon,
  StorefrontIcon,
  ShoppingCartSimpleIcon,
  MartiniIcon,
  ForkKnifeIcon,
  CoffeeIcon,
  BabyIcon,
  BusIcon,
  TrainIcon,
  TrafficSignalIcon,
  TreeIcon,
  BarbellIcon,
  BrainIcon,
  PawPrintIcon,
  GasPumpIcon,
  HeartbeatIcon,
  PaletteIcon,
  ArmchairIcon,
  BackpackIcon,
  GraduationCapIcon,
  MapPinIcon,
  AirplaneIcon,
  WineIcon,
  BankIcon,
  DiceThreeIcon,
  CoatHangerIcon,
  ShoppingBagIcon,
  ChalkboardTeacherIcon,
  ToteIcon,
  BuildingsIcon,
  PopcornIcon,
  HospitalIcon,
  BooksIcon,
  PillIcon,
  ReceiptIcon,
  CourtBasketballIcon,
} from "@phosphor-icons/react";
import type { POIs, EnhancedPOIs, Schools } from "@local-logic/client";

type POIDeprecated = keyof POIs | keyof Schools;
type POI = EnhancedPOIs | keyof Schools;

export const iconsDeprecated: {
  [key in POIDeprecated | "other"]: Icon;
} = {
  groceries: StorefrontIcon,
  groceries_specialized: StorefrontIcon,
  shopping: ShoppingCartSimpleIcon,
  nightlife: MartiniIcon,
  restaurants: ForkKnifeIcon,
  healthy_restaurants: ForkKnifeIcon,
  cafes: CoffeeIcon,
  daycares: BabyIcon,
  bus_stops: BusIcon,
  rapid_transit_stations: TrainIcon,
  train_stations: TrafficSignalIcon,
  parks: TreeIcon,
  fitness: BarbellIcon,
  sport_facilities: BarbellIcon,
  personal_care: BrainIcon,
  pet_care: PawPrintIcon,
  car_fueling_stations: GasPumpIcon,
  health_care: HeartbeatIcon,
  art_culture_science: PaletteIcon,
  home_improvement: ArmchairIcon,
  primary_schools: BackpackIcon,
  high_schools: GraduationCapIcon,
  other: MapPinIcon,
};

export const icons: {
  [key in POI | "other"]: Icon;
} = {
  airports: AirplaneIcon,
  alcohol: WineIcon,
  art_culture_science: PaletteIcon,
  banks: BankIcon,
  bus_stops: BusIcon,
  cafes: CoffeeIcon,
  car_fueling_stations: GasPumpIcon,
  casino: DiceThreeIcon,
  clothing: CoatHangerIcon,
  common_needs: ShoppingBagIcon,
  conference_centers: ChalkboardTeacherIcon,
  convenience_stores: ToteIcon,
  daycares: BabyIcon,
  department_stores: BuildingsIcon,
  entertainment: PopcornIcon,
  fitness: BarbellIcon,
  groceries: StorefrontIcon,
  groceries_specialized: StorefrontIcon,
  health_care: HeartbeatIcon,
  home_improvement: ArmchairIcon,
  hospitals: HospitalIcon,
  libraries: BooksIcon,
  nightlife: MartiniIcon,
  non_food_shops: ShoppingCartSimpleIcon,
  parks: TreeIcon,
  personal_care: BrainIcon,
  pet_care: PawPrintIcon,
  pharmacies: PillIcon,
  rapid_transit_stations: TrainIcon,
  restaurants: ForkKnifeIcon,
  retail: ReceiptIcon,
  shops_and_services: StorefrontIcon,
  sport_facilities: CourtBasketballIcon,
  train_stations: TrafficSignalIcon,
  // Schools - from Schools API
  primary_schools: BackpackIcon,
  high_schools: GraduationCapIcon,
  other: MapPinIcon,
};

export const PoiIconDeprecated = ({
  poi,
  className,
}: {
  poi: POIDeprecated;
  className?: string;
}) => {
  const Icon = useMemo(() => iconsDeprecated[poi], [poi]);

  return <Icon className={className} />;
};

export const POIIcon = ({
  poi,
  className,
}: {
  poi: EnhancedPOIs;
  className?: string;
}) => {
  const Icon = useMemo(() => icons[poi], [poi]);

  return <Icon className={className} />;
};
